import React, { useEffect, useContext, useState } from "react";
import { styles } from "./patients/dashboardstyle";

import api, { API_URL, showAlert, AuthContext, toNaira } from "./util/api";
import { Link, useNavigate } from "react-router-dom";

import Navbar from "./header";
import Footer from "./footer";
import "./paginationstyle.css";
import PremiumLoader from "./loading";
import NoData from "./components/nodata";

export default function Transactions() {

    const { User, token, Doctor, Patient } = useContext(AuthContext);
    const [loading, setLoader] = useState(true);
    const [balance, setbalance] = useState(0);
    const [Withdrawn, setwithdrawn] = useState(0);
    const [dashboardLink, setDashoardLink] = useState("");

    const router = useNavigate();

    const [transactions, setTransactions] = useState([]);

    const [hovered, setHovered] = React.useState(null);

    // 🔹 Withdraw States
    const [showWithdrawModal, setShowWithdrawModal] = useState(false);
    const [withdrawType, setWithdrawType] = useState("bank");
    const [withdrawAmount, setWithdrawAmount] = useState("");
    const [withdrawLoading, setWithdrawLoading] = useState(false);

    const fadeIn = { animation: "fadeIn 0.8s ease-out" };
    const slideUp = { animation: "slideUp 0.8s ease-out" };

    const [pagination, setPagination] = useState({
        current_page: 1,
        last_page: 1,
        next_page_url: null,
        prev_page_url: null,
    });

    // FETCH DATA
    const getdata = async (page = 1) => {
        setLoader(true);
        const response = await api.get(`${API_URL}/transactions?page=${page}`);

        if (response.data.status === "success") {
            let info = response.data;

            setTransactions(info.transactions.data);
            setwithdrawn(info.withdrawn);
            setbalance(info.balance);

            setPagination({
                current_page: info.transactions.current_page,
                last_page: info.transactions.last_page,
                next_page_url: info.transactions.next_page_url,
                prev_page_url: info.transactions.prev_page_url,
            });

            setLoader(false);
        } else {
            showAlert("error", "Error!", response.data.message);
            setLoader(false);
        }
    };

    const handlePageChange = (page) => {
        if (page >= 1 && page <= pagination.last_page) {
            getdata(page);
        }
    };

    // 🔹 Withdraw Submit
    const handleWithdraw = async () => {

        if (!withdrawAmount || withdrawAmount <= 0) {
            return showAlert("error", "Invalid Amount", "Enter a valid withdrawal amount.");
        }


        /*    if (withdrawAmount > balance) {
               return showAlert("error", "Insufficient Balance", "Withdrawal exceeds wallet balance.");
           } */

        try {
            setWithdrawLoading(true);

            const response = await api.post(`${API_URL}/withdraw`, {
                amount: withdrawAmount,
                type: withdrawType
            });

            if (response.data.status === "success") {
                showAlert("success", "Success", response.data.message);
                setShowWithdrawModal(false);
                setWithdrawAmount("");
                getdata();
            } else {
                setShowWithdrawModal(false);
                setWithdrawAmount("");
                showAlert("error", "Error", response.data.message);
            }

        } catch (err) {

            setShowWithdrawModal(false);
            setWithdrawAmount("");
            showAlert("error", "Error", "Something went wrong.");
        }

        setWithdrawLoading(false);
    };

    useEffect(() => {
        if (User == null || token == null) {
            router("/login");
        } else {
            if (Doctor != null) setDashoardLink("/doctor-dashboard");
            if (Patient != null) setDashoardLink("/patient-dashboard");
        }

        getdata();
    }, []);

    return (
        <>
            <Navbar menuColor="red" />

            <section>
                <div style={styles.container}>

                    {/* TOP CARD */}
                    <div style={{ ...styles.card, ...fadeIn }}>

                        <div style={styles.header}>
                            <Link to={dashboardLink}>
                                <button
                                    onClick={() => router(-1)}
                                    style={{
                                        background: "transparent",
                                        border: "none",
                                        color: "#007bff",
                                        cursor: "pointer",
                                        fontSize: 16,
                                        padding: 0,
                                    }}
                                >
                                    ← Back
                                </button>
                            </Link>
                        </div>

                        <br />

                        <div style={styles.grid}>
                            {[
                                { label: "Wallet Balance", value: toNaira(balance), Link: "/wallet-balance" },
                                { label: "Withdrawn", value: toNaira(Withdrawn), Link: "/withdraw-history" },
                            ].map((item, index) => (
                                <div
                                    key={index}
                                    style={{
                                        ...styles.statBox,
                                        ...(hovered === index && styles.statBoxHover),
                                        ...slideUp,
                                    }}
                                    onMouseEnter={() => setHovered(index)}
                                    onMouseLeave={() => setHovered(null)}
                                >
                                    <Link to={item.Link}>
                                        <div style={styles.statLabel}>{item.label}</div>
                                        <div style={styles.statValue}>{item.value}</div>
                                    </Link>
                                </div>
                            ))}
                        </div>

                        {/* 🔥 Withdraw Button */}
                        <div style={{ marginTop: 25, textAlign: "center" }}>
                            <button
                                onClick={() => setShowWithdrawModal(true)}
                                style={{
                                    padding: "12px 30px",
                                    background: "linear-gradient(135deg, #ff416c, #ff4b2b)",
                                    border: "none",
                                    borderRadius: 50,
                                    color: "#fff",
                                    fontSize: 16,
                                    fontWeight: 600,
                                    cursor: "pointer",
                                    boxShadow: "0 8px 20px rgba(255,75,43,0.4)",
                                    transition: "0.3s ease"
                                }}
                            >
                                Withdraw Funds
                            </button>


                            &nbsp;


                             <button
                                onClick={() => router("/withdraw-history")}
                                style={{
                                    padding: "12px 30px",
                                    background: "linear-gradient(135deg, #11f081ff, #0cf146ff)",
                                    border: "none",
                                    borderRadius: 50,
                                    color: "#fff",
                                    fontSize: 16,
                                    fontWeight: 600,
                                    cursor: "pointer",
                                    boxShadow: "0 8px 20px rgba(255,75,43,0.4)",
                                    transition: "0.3s ease"
                                }}
                            >
                                Withdraw History
                            </button>
                        </div>
                    </div>

                    {/* TABLE CARD (UNCHANGED FUNCTIONALITY) */}
                    <div style={{ ...styles.card, ...fadeIn }}>
                        <div style={styles.header}>Transactions</div>
                        <br />

                        {loading ? (
                            <PremiumLoader />
                        ) : transactions.length === 0 ? (
                            <NoData />
                        ) : (
                            <>
                                <div style={styles.tableContainer}>
                                    <table style={styles.table}>
                                        <thead>
                                            <tr>
                                                <th style={styles.th}>Amount</th>
                                                <th style={styles.th}>Type</th>
                                                <th style={styles.th}>Status</th>
                                                <th style={styles.th}>Description</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {transactions.map((row, index) => (
                                                <tr key={index}>
                                                    <td style={styles.td}>{toNaira(row.amount)}</td>
                                                    <td style={styles.td}>{row.type || " "}</td>
                                                    <td style={styles.td}>{row.status || " "}</td>
                                                    <td style={styles.td}>{row.description}</td>
                                                </tr>
                                            ))}
                                        </tbody>
                                    </table>
                                </div>
                            </>
                        )}
                    </div>


                    {/* PAGINATION */}
                    <div style={{ marginTop: 20, textAlign: "center" }}>
                        {pagination.last_page > 1 && (
                            <div style={{ display: "inline-flex", gap: 8, flexWrap: "wrap" }}>

                                {/* PREVIOUS BUTTON */}
                                <button
                                    onClick={() => handlePageChange(pagination.current_page - 1)}
                                    disabled={!pagination.prev_page_url}
                                    style={{
                                        padding: "8px 14px",
                                        borderRadius: 6,
                                        border: "1px solid #ddd",
                                        background: pagination.prev_page_url ? "#fff" : "#eee",
                                        cursor: pagination.prev_page_url ? "pointer" : "not-allowed"
                                    }}
                                >
                                    Prev
                                </button>

                                {/* PAGE NUMBERS */}
                                {[...Array(pagination.last_page)].map((_, index) => {
                                    const pageNumber = index + 1;

                                    return (
                                        <button
                                            key={pageNumber}
                                            onClick={() => handlePageChange(pageNumber)}
                                            style={{
                                                padding: "8px 12px",
                                                borderRadius: 6,
                                                border: "1px solid #ddd",
                                                background:
                                                    pagination.current_page === pageNumber
                                                        ? "#007bff"
                                                        : "#fff",
                                                color:
                                                    pagination.current_page === pageNumber
                                                        ? "#fff"
                                                        : "#000",
                                                cursor: "pointer"
                                            }}
                                        >
                                            {pageNumber}
                                        </button>
                                    );
                                })}

                                {/* NEXT BUTTON */}
                                <button
                                    onClick={() => handlePageChange(pagination.current_page + 1)}
                                    disabled={!pagination.next_page_url}
                                    style={{
                                        padding: "8px 14px",
                                        borderRadius: 6,
                                        border: "1px solid #ddd",
                                        background: pagination.next_page_url ? "#fff" : "#eee",
                                        cursor: pagination.next_page_url ? "pointer" : "not-allowed"
                                    }}
                                >
                                    Next
                                </button>

                            </div>
                        )}
                    </div>
                </div>
            </section>

            {/* 🔥 BEAUTIFUL MODAL */}
            {showWithdrawModal && (
                <div style={{
                    position: "fixed",
                    top: 0,
                    left: 0,
                    width: "100%",
                    height: "100%",
                    background: "rgba(0,0,0,0.6)",
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    zIndex: 9999
                }}>
                    <div style={{
                        width: "95%",
                        maxWidth: 450,
                        background: "#fff",
                        borderRadius: 20,
                        padding: 30,
                        boxShadow: "0 20px 50px rgba(0,0,0,0.2)"
                    }}>
                        <h3 style={{ marginBottom: 20, textAlign: "center" }}>Withdraw Funds</h3>

                        <div style={{ marginBottom: 15 }}>
                            <label>Select Withdrawal Method</label>
                            <select
                                value={withdrawType}
                                onChange={(e) => setWithdrawType(e.target.value)}
                                style={{
                                    width: "100%",
                                    padding: 10,
                                    borderRadius: 8,
                                    marginTop: 5
                                }}
                            >
                                <option value="bank">Bank Deposit</option>
                                <option value="crypto">Crypto Deposit</option>
                            </select>
                        </div>

                        <div style={{ marginBottom: 20 }}>
                            <label>Amount</label>
                            <input
                                type="number"
                                placeholder="Enter amount"
                                value={withdrawAmount}
                                onChange={(e) => setWithdrawAmount(e.target.value)}
                                style={{
                                    width: "100%",
                                    padding: 10,
                                    borderRadius: 8,
                                    marginTop: 5
                                }}
                            />
                        </div>

                        <div style={{ display: "flex", justifyContent: "space-between" }}>
                            <button
                                onClick={() => setShowWithdrawModal(false)}
                                style={{
                                    padding: "10px 20px",
                                    borderRadius: 8,
                                    border: "none",
                                    background: "#ccc",
                                    cursor: "pointer"
                                }}
                            >
                                Cancel
                            </button>

                            <button
                                onClick={handleWithdraw}
                                disabled={withdrawLoading}
                                style={{
                                    padding: "10px 25px",
                                    borderRadius: 8,
                                    border: "none",
                                    background: "#28a745",
                                    color: "#fff",
                                    fontWeight: 600,
                                    cursor: "pointer"
                                }}
                            >
                                {withdrawLoading ? "Processing..." : "Submit"}
                            </button>
                        </div>
                    </div>
                </div>
            )}

            <Footer />
        </>
    );
}